module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"unlocking":"\\"{name}\\" ermöglicht es Dir, die folgenden Artikel zu kaufen"},"en":{"unlocking":"With \\"{name}\\", you will be able to purchase the following items"}}')
  delete Component.options._Ctor
}
